import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogTrigger } from 'shared/components/ui/dialog';
import { FinecoButton } from '../../../../FinecoButton';

import styles from './ConfirmDeleteModal.module.scss';

type ConfirmDeleteModalProps = {
  listName: string;
  onConfirm: () => Promise<void>;
  children: React.ReactNode;
};

export const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({ listName, onConfirm, children }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const handleConfirm = async () => {
    setDeleting(true);

    try {
      await onConfirm();
      setOpen(false);
    } catch (error) {
      // Error handled by parent
    } finally {
      setDeleting(false);
    }
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent title={t('instrumentLists.deleteList')} className={styles.dialogContent} centerTitle>
        <div className={styles.modalBody}>
          <p className={styles.confirmMessage}>{t('instrumentLists.deleteListConfirm')}</p>
          <p className={styles.listName}>{listName}</p>
        </div>

        <div className={styles.modalFooter}>
          <FinecoButton
            className={styles.cancelButton}
            click={handleCancel}
            variant="white"
            copy={t('actions.cancel')}
            disabled={deleting}
          />
          <FinecoButton
            className={styles.deleteButton}
            click={handleConfirm}
            copy={deleting ? t('actions.deleting') : t('instrumentLists.deleteList')}
            disabled={deleting}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
